<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card">
        <div class="card-body">
            <h5>
                البيانات العامة
            </h5>
            <hr>
            <div class="form-group">
              <span for="">إسم المدرسة</span>
              <input type="text"
                class="form-control" v-model="school_name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <span for="">إسم مدير المدرسة</span>
              <input type="text"
                class="form-control" v-model="admin_name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <span for="">إسم الرئيس المباشر</span>
              <input type="text"
                class="form-control" v-model="boss_name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <span>توقيع الرئيس المباشر (التوقيع الافتراضي للمسائلات)</span>
              <div v-if="!default_signature" style="margin-top: 8px;">
                <div style="border: 2px solid #ccc; border-radius: 8px; background: #fff; position: relative; touch-action: none;">
                  <canvas ref="sigCanvas" width="400" height="150" style="width: 100%; height: 150px; cursor: crosshair; display: block;"></canvas>
                  <button class="btn btn-sm btn-outline-danger" style="position: absolute; top: 5px; left: 5px;" @click="clearSig()">
                    <i class="fa fa-trash"></i> مسح
                  </button>
                </div>
              </div>
              <div v-if="default_signature" style="margin-top: 8px;">
                <img :src="default_signature" style="max-width: 250px; border: 1px solid #eee; border-radius: 5px;">
                <br>
                <button class="btn btn-sm btn-outline-warning" style="margin-top: 5px;" @click="default_signature = null; $nextTick(function(){ initSig(); })">
                  <i class="fa fa-refresh"></i> تغيير التوقيع
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-primary" @click="save()">
                    حفظ
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            school_name: "",
            admin_name: "",
            boss_name: "",
            default_signature: null,
            sigCtx: null,
            user: JSON.parse(localStorage.getItem('user')),
        }
    },
    created(){
      if(!checkPer("teachers|settings")){
          this.$router.push('/NotPermitted')
          return false;
      }
        var g = this;
        $.post(api + '/user/teachers/info', {
            jwt: g.user.jwt
        }).then(function(r){
            g.school_name = r.response.school_name;
            g.admin_name = r.response.admin_name;
            g.boss_name = r.response.boss_name;
            g.default_signature = r.response.default_signature || null;
            if(!g.default_signature){
                g.$nextTick(function(){ g.initSig(); })
            }
        })
    },
    methods: {
        initSig(){
            var g = this;
            var canvas = g.$refs.sigCanvas;
            if(!canvas) return;
            g.sigCtx = canvas.getContext('2d');
            g.sigCtx.strokeStyle = '#000';
            g.sigCtx.lineWidth = 2;
            g.sigCtx.lineCap = 'round';
            g.sigCtx.lineJoin = 'round';
            var isDrawing = false;
            function getPos(e){
                var rect = canvas.getBoundingClientRect();
                var scaleX = canvas.width / rect.width;
                var scaleY = canvas.height / rect.height;
                if(e.touches && e.touches.length > 0){
                    return { x: (e.touches[0].clientX - rect.left) * scaleX, y: (e.touches[0].clientY - rect.top) * scaleY }
                }
                return { x: (e.clientX - rect.left) * scaleX, y: (e.clientY - rect.top) * scaleY }
            }
            function startDraw(e){ e.preventDefault(); isDrawing = true; var pos = getPos(e); g.sigCtx.beginPath(); g.sigCtx.moveTo(pos.x, pos.y); }
            function draw(e){ if(!isDrawing) return; e.preventDefault(); var pos = getPos(e); g.sigCtx.lineTo(pos.x, pos.y); g.sigCtx.stroke(); }
            function stopDraw(e){ if(isDrawing){ e.preventDefault(); isDrawing = false; } }
            canvas.addEventListener('mousedown', startDraw);
            canvas.addEventListener('mousemove', draw);
            canvas.addEventListener('mouseup', stopDraw);
            canvas.addEventListener('mouseleave', stopDraw);
            canvas.addEventListener('touchstart', startDraw);
            canvas.addEventListener('touchmove', draw);
            canvas.addEventListener('touchend', stopDraw);
        },
        clearSig(){
            var canvas = this.$refs.sigCanvas;
            if(canvas && this.sigCtx){ this.sigCtx.clearRect(0, 0, canvas.width, canvas.height); }
        },
        getSigData(){
            var canvas = this.$refs.sigCanvas;
            if(!canvas) return null;
            var pixels = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data;
            for(var i = 3; i < pixels.length; i += 4){ if(pixels[i] > 0) return canvas.toDataURL('image/png'); }
            return null;
        },
        save(){
            var g = this;
            var sig = g.default_signature || g.getSigData();
            var postData = {
                jwt: g.user.jwt,
                school_name: g.school_name,
                admin_name: g.admin_name,
                boss_name: g.boss_name
            };
            if(sig){
                postData.default_signature = sig;
            }
            $.post(api + '/user/teachers/info/save', postData).then(function(r){
                if(sig) g.default_signature = sig;
                alert("تم الحفظ", 100)
            })
        }
    }
}
</script>

<style>

</style>
